import { Divider } from 'antd';
import React from 'react';
import { useTheme } from 'src/styles/theme';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAppDividerProps {
  color?: string;
  mt?: number | string;
  mb?: number | string;
  className?: string;
}

const AppDivider: React.FunctionComponent<IAppDividerProps> = (props) => {
  // TOOLS
  const theme = useTheme();
  // PROPS
  const { color, mt, mb, className } = props;

  // STATE

  // SELECTORS

  // VIEW
  return (
    <Divider
      className={className}
      style={{
        borderColor: theme.colors.appGrey || color,
        marginTop: mt,
        marginBottom: mb
      }}
    />
  );
};

export default AppDivider;
